'use client';

import { NativeImage } from "./chunk-X3PS6RUF.mjs";

// src/img.tsx
import { chakra, forwardRef } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var Img = forwardRef((props, ref) => /* @__PURE__ */jsx(chakra.img, {
  ref,
  as: NativeImage,
  className: "chakra-image",
  ...props
}));
export { Img };